import React, { FC, FormEvent, useMemo, useRef, useState } from 'react';

import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
//devextreme
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { CheckBox, NumberBox, SelectBox, TextArea } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

import {
  useCreateTransportMutation,
  useEditTransportMutation,
  useLazyGetTransportDetailQuery,
  useLazyGetTransportTypesQuery,
} from 'bus/transport/transport';
import { TransportItemFull } from 'bus/transport/types';

type Props = {
  id: number | null;
  contractorId: number;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const initialForm = {
  id: null,
  contractorId: null,
  transportType: null,
  comment: '',
  vinCode: '',
  number: '',
  customName: '',
  modelId: null,
  quantity: 0,
  weight: 0,
  isDeleted: false,
  calculatePayment: false,
};

const EditModal: FC<Props> = (props) => {
  const [getTransportDetail] = useLazyGetTransportDetailQuery();
  const [getTransportTypes, { data }] = useLazyGetTransportTypesQuery();
  const [createTransport, { isLoading: isCreateLoading }] = useCreateTransportMutation();
  const [editTransport, { isLoading: isEditLoading }] = useEditTransportMutation();

  const modelsDataStore: DataSource = useMemo(
    () => $createDataSource('/v1/TransportModel', 'id', { pageSize: 10, paginate: true }),
    [],
  );

  let createCatalogGroupRef = useRef<any>(null);
  let createCatalogGroupValidationRef = useRef<any>(null);

  const [form, setForm] = useState<TransportItemFull>({ ...initialForm });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    setLoading(true);
    e.preventDefault && e.preventDefault();
    if (createCatalogGroupValidationRef.current.instance.validate().isValid) {
      if (props.id) {
        await editTransport({ ...form, contractorId: props.contractorId }).then((resp: any) => {
          if (isSuccess(resp)) {
            props.refresh();
            props.changeVisible(false);
          }
        });
      } else {
        await createTransport({ ...form, id: 0, contractorId: props.contractorId }).then((resp: any) => {
          if (isSuccess(resp)) {
            props.refresh();
            props.changeVisible(false);
          }
        });
      }
    }
    setLoading(false);
  };

  const onShown = async () => {
    await getTransportTypes();
    createCatalogGroupValidationRef.current.instance.reset();
    if (props.id) {
      await getTransportDetail({ id: props.id }).then((data) => {
        console.log('data', data);

        if (isSuccess(data)) {
          setForm((prev) => ({ ...prev, ...data.data }));
        }
      });
    }
  };

  const onHidden = () => {
    setForm({ ...initialForm });
    setTimeout(() => {
      createCatalogGroupRef.current.instance.resetValues();
    }, 0);
  };

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={() => props.changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Транспорт"
        width={700}
        onShowing={() => onShown()}
        onHidden={() => onHidden()}
        height={'auto'}
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createCatalogGroupValidationRef}>
                <Form formData={form} ref={createCatalogGroupRef}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Тип транспорта" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите тип"
                            mode="text"
                            value={form.transportType}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, transportType: e, customName: '' }));
                            }}
                            displayExpr="name"
                            valueExpr="id"
                            dataSource={data}
                          ></SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Номер" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Введите номер"
                            mode="text"
                            value={form.number}
                            onValueChange={(e: any) => {
                              setForm((prev) => ({ ...prev, number: e }));
                            }}
                            mask="L 000 LL 009"
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Номер" />
                            </Validator>
                          </TextBox>
                        </AppFiledBox>

                        <AppFiledBox label="Марка" labelTop>
                          {/*  <TextBox
                              stylingMode="underlined"
                                placeholder="Введите марку"
                                mode="text"
                                value={form.modelId}
                                onChange={(e: any) =>{
                                    setForm((prev) => ({...prev, modelId: e.event.currentTarget.value}))
                                }}
                            >
                                <Validator>
                                    <RequiredRule message="Заполните поле марку" />
                                </Validator>
                            </TextBox> */}
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите"
                            value={form.modelId}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, modelId: e }));
                            }}
                            displayExpr="name"
                            valueExpr="id"
                            dataSource={modelsDataStore}
                          ></SelectBox>
                        </AppFiledBox>

                        <AppRow>
                          <AppGroup col={12}>
                            <AppFiledBox label={form.transportType === 0 ? 'Метраж' : 'Объём'} labelTop>
                              <NumberBox
                                stylingMode="underlined"
                                placeholder={form.transportType === 0 ? 'Введите метраж' : 'Введите объём'}
                                //mode="number"
                                format="###0.##"
                                value={form.quantity}
                                onValueChanged={(e: any) => {
                                  setForm((prev) => ({ ...prev, quantity: e.value }));
                                }}
                              >
                                <Validator>
                                  <RequiredRule message="Заполните поле объём" />
                                </Validator>
                              </NumberBox>
                            </AppFiledBox>
                          </AppGroup>
                        </AppRow>

                        <AppFiledBox label="Вес" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="Введите вес"
                            //mode="number"
                            format="###0.##"
                            value={form.weight}
                            onValueChanged={(e: any) => {
                              setForm((prev) => ({ ...prev, weight: e.value || 0 }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле вес" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>

                        <AppFiledBox label="Vin-code" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Введите vin-code"
                            value={form.vinCode}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, vinCode: e.event.currentTarget.value }));
                            }}
                          ></TextBox>
                        </AppFiledBox>

                        {form.transportType === 0 && (
                          <AppFiledBox label="Доп. наименование" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder="Введите Доп. наименование"
                              value={form.customName}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, customName: e.event.currentTarget.value }));
                              }}
                            ></TextBox>
                          </AppFiledBox>
                        )}

                        {form.transportType === 0 && (
                          <AppFiledBox label="" labelTop>
                            <CheckBox
                              value={form.calculatePayment}
                              text="Считать оплату"
                              onValueChanged={(e) => setForm((prev) => ({ ...prev, calculatePayment: e.value }))}
                            />
                          </AppFiledBox>
                        )}

                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          ></TextArea>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => props.changeVisible(false)}
                  disabledSubmit={loading || isCreateLoading || isEditLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default EditModal;
